export default __webpack_public_path__ + "static/media/arrow.a11d637f.svg";